module.exports = __webpack_public_path__ + "media/dogs/puppy-fetching-box-217f383f.svg";